import { View, Pressable, StyleSheet } from "react-native";
import { BlurView } from "expo-blur";
import { MoonText } from "@louise/moon-ui/primitives/MoonText";
import StatusBadge from "./StatusBadge";

import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
type ComingSoonOverlayProps = {
  children: React.ReactNode;
  description?: string;
  onPress?: () => void;
  /** Stable analytics identifier for the surface this overlay covers. */
  action?: string;
};

export default function ComingSoonOverlay({
  children,
  description,
  onPress,
  action,
}: ComingSoonOverlayProps) {
  const capturePress = usePressCapture("ComingSoonOverlay");
  const overlay = (
    <View className="absolute inset-0 items-center justify-center">
      <BlurView intensity={60} tint="light" style={StyleSheet.absoluteFill} />
      <View className="items-center px-4">
        <StatusBadge type="coming-soon" />
        {description ? (
          <MoonText color="textLight" className="mt-2 text-center">
            {description}
          </MoonText>
        ) : null}
      </View>
    </View>
  );

  return (
    <View className="overflow-hidden rounded-2xl">
      {children}
      {onPress ? (
        <Pressable
          style={StyleSheet.absoluteFill}
          onPress={() => {
            capturePress(
              pressLabel("Coming soon. Tap to learn more"),
              action ?? "coming_soon_overlay",
            );
            onPress();
          }}
          accessibilityRole="button"
          accessibilityLabel="Coming soon. Tap to learn more"
        >
          {overlay}
        </Pressable>
      ) : (
        overlay
      )}
    </View>
  );
}
